type TreeNode = {
  type?: unknown;
  content?: unknown;
};

const isTreeNode = (value: unknown): value is TreeNode => typeof value === 'object' && value !== null;

export function hasNodeOfType(content: unknown, type: string): boolean {
  if (!isTreeNode(content)) return false;
  if (content.type === type) return true;
  if (!Array.isArray(content.content)) return false;

  return content.content.some((child) => hasNodeOfType(child, type));
}
